import React, { useEffect, useState } from "react";
import "./Invoice.css";
import axios from "axios";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import { useParams } from "react-router-dom";

const MultiRowPrint = () => {
  const { id, route } = useParams();
  const [company, setCompany] = useState({});
  const [headerData, setHeaderData] = useState({});
  const [items, setItems] = useState({});
  const [columns, setColumns] = useState([]);
  const [footerData, setFooterData] = useState({});

  const [isSignatureShow, setIsSignatureShow] = useState(false);

  useEffect(() => {
    if (route.includes("InPatient") || route.includes("Discharge")) {
      setIsSignatureShow(true);
    } else {
      setIsSignatureShow(false);
    }
  }, [route]);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );
        const companyData = response.data.company[0];
        setCompany(companyData);

        if (companyData?.name) document.title = companyData.name;
        if (companyData?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) favicon.href = companyData.logo;
        }
      } catch (error) {
        console.log("Error fetching company:", error);
      }
    };
    fetchCompany();
  }, []);

  useEffect(() => {
    console.log("type:", route);
    const fetchReport = async () => {
      const body = { id: id };
      const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
      try {
        const result = await postData(url, body);
        const header = result.data.find((d) => d.title === "header");
        const itemsData = result.data
          .filter((d) => d.title === "items")
          .map((d) => d.table || d.fields)
          .flat();
        const footer = result.data.find((d) => d.title === "Footer");

        const grouped = itemsData.reduce((acc, item) => {
          const key = item.item_group || "Other";
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        setHeaderData(header?.fields || {});
        setFooterData(footer?.fields || {});
        setItems(grouped);

        if (itemsData.length > 0) {
          const keys = Object.keys(itemsData[0]);
          setColumns(keys);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchReport();
  }, [id]);

  return (
    <div className="invoice-container">
      <div className="header-row">
        {company.banner && (
          <div className="banner-container">
            <img src={`${API_URL}/${company.banner}`} alt="Company Banner" />
          </div>
        )}
        <button className="print-btn" onClick={() => window.print()}>
          Print Invoice
        </button>
      </div>

      {/* Header Section */}
      <div className="patient-details-grid">
        {Object.entries(headerData).map(([key, value]) => (
          <div key={key} className="grid-item">
            <span className="label">{key}:</span>
            <span className="value">{value}</span>
          </div>
        ))}
      </div>

      {/* Table */}
      <table className="items-table">
        <thead>
          <tr>
            <th>No</th>
            {columns
              .filter((col) => col !== "title" && col !== "item_group")
              .map((col) => (
                <th key={col}>{col}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {(() => {
            let rowNumber = 1;
            return Object.keys(items).map((group) => {
              const groupItems = items[group];
              return groupItems.map((item, index) => (
                <tr key={`${group}-${index}`}>
                  <td>{rowNumber++}</td>
                  {columns
                    .filter((col) => col !== "title" && col !== "item_group")
                    .map((col) => (
                      <td
                        key={col}
                        className={
                          col.toLowerCase().includes("price") ||
                          col.toLowerCase().includes("amount")
                            ? "right-align"
                            : ""
                        }
                      >
                        {item[col]}
                      </td>
                    ))}
                </tr>
              ));
            });
          })()}
        </tbody>
      </table>

      {/* Footer + Signature */}
      <div
        className={`footer-signature-row ${
          !isSignatureShow ? "only-totals" : ""
        }`}
      >
        {/* Signature Column */}
        {isSignatureShow && (
          <div className="signature-section mb-3">
            <div className="signature-row">
              <div className="signature-label-group">
                <span className="signature-label">Approved By:</span>
                <span className="signature-line"></span>
              </div>
              <div className="signature-label-group">
                <span className="signature-label">Sign</span>
                <span className="signature-line"></span>
              </div>
              <div className="signature-label-group">
                <span className="signature-label">Date:</span>
                <span className="signature-line"></span>
              </div>
            </div>

            <div className="signature-row">
              <div className="signature-label-group">
                <span className="signature-label">Discharged By:</span>
                <span className="signature-line"></span>
              </div>
              <div className="signature-label-group">
                <span className="signature-line"></span>
              </div>
              <div className="signature-label-group">
                <span className="signature-line"></span>
              </div>
            </div>
          </div>
        )}

        {/* Footer Column */}
        {route !== "More-nurse" && (
          <div className="totals-section">
            {Object.keys(footerData).map((key) => (
              <div key={key} className="total-row">
                <span className="total-key">{key}:</span>
                <span className="total-value">{footerData[key]}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiRowPrint;